
  import { Component, Vue } from 'vue-property-decorator';
  import { inject } from 'inversify-props';
  import {IAuthService} from '@/services/auth-service';

  @Component
  export default class SigninOidcSilent extends Vue {
    @inject()
    private authService!: IAuthService;

    mounted () {
      this.authService.finishLoginSilent();
    }
  }
